import { PartyIsActiveFilter, PartySearchQueryArgs } from '../Types/partyTypes';

const normalizeSearchTerm = (search: string | undefined): string | undefined => {
  const trimmed = search?.trim();
  return trimmed ? trimmed : undefined;
};

const mapIsActiveFilterToQueryValue = (
  filter: PartyIsActiveFilter | undefined
): 'true' | 'false' | undefined => {
  if (filter === 'active') {
    return 'true';
  }

  if (filter === 'inactive') {
    return 'false';
  }

  return undefined;
};

export const buildPartySearchQuery = (args: PartySearchQueryArgs): string => {
  const queryParams = new URLSearchParams();
  const normalizedSearch = normalizeSearchTerm(args.search);
  const page = Number.isFinite(args.page) && (args.page ?? 0) > 0 ? args.page : 1;
  const pageSize =
    Number.isFinite(args.pageSize) && (args.pageSize ?? 0) > 0 ? Math.trunc(args.pageSize ?? 20) : 20;
  const sortBy = args.sortBy?.trim() || 'name';
  const sortDir = args.sortDir === 'desc' ? 'desc' : 'asc';
  const isActive = mapIsActiveFilterToQueryValue(args.isActive);

  if (normalizedSearch) {
    queryParams.set('search', normalizedSearch);
  }

  queryParams.set('page', String(page));
  queryParams.set('pageSize', String(pageSize));
  queryParams.set('sortBy', sortBy);
  queryParams.set('sortDir', sortDir);

  if (isActive) {
    queryParams.set('isActive', isActive);
  }

  return `/parties/search?${queryParams.toString()}`;
};

